/**
 * Laravel Frontend scripts
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

import '@babel/polyfill'
import 'promise-polyfill/src/polyfill'
import Application from './core'

import $ from 'jquery'
import 'jquery.mmenu'
import 'bootstrap'
import 'magnific-popup'

/** and expose it to browser window object */
window.$ = $
window.App = new Application()

function offsetAnchor () {
  if (location.hash.length !== 0) {
    window.scrollTo(window.scrollX, window.scrollY - 200)
  }
}
$(document).on('click', 'a[href^="#"]', function (event) {
  window.setTimeout(function () {
    offsetAnchor()
  }, 0)
})
window.setTimeout(offsetAnchor, 0)

$(document).ready(function () {
  if ($('.popup-gallery').length) {
    $('.popup-gallery').each(function () {
      $(this).magnificPopup({
        delegate: 'a.popUpImage',
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
        },
        image: {
          tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
          titleSrc: function (item) {
            return item.el.attr('title')
          }
        }
      })
    })
  }
  if ($('#typewriteText').length) {
    typeWriter();
  }

  var buttoR = document.getElementById('slideRight');
  buttoR.onclick = function () {
    let numberOfItems = parseInt(document.getElementById('popularItemsinView').dataset.popular);
    let firstId = parseInt(document.getElementById('popularItemsinView').dataset.firstid);
    let count = 1;
    let lastToBeChecked = 0;

    for(let i=1; i<=numberOfItems; i++) {
      if(i == firstId) {
        document.getElementById('popItem'+i).classList.add('posLeftOut');
        document.getElementById('popItem'+i).classList.remove('pos'+count);
        count++;
      } else if(i > firstId && count <= 4) {
        document.getElementById('popItem'+i).classList.add('pos' + (count - 1));
        document.getElementById('popItem'+i).classList.remove('pos' + count);
        count++;
      } else if(i > firstId && count == 5) {
        document.getElementById('popItem'+i).classList.add('pos' + (count - 1));
        document.getElementById('popItem'+i).classList.remove('posRightOut');
        lastToBeChecked = i;
        count++;
      }
    }
    document.getElementById('slideLeft').classList.add('show');
    if(lastToBeChecked == numberOfItems) {
      document.getElementById('slideRight').classList.remove('show');
    }
    document.getElementById('popularItemsinView').dataset.firstid = firstId + 1;
  };

  var buttonL = document.getElementById('slideLeft');
  buttonL.onclick = function () {
    let numberOfItems = parseInt(document.getElementById('popularItemsinView').dataset.popular);
    let firstId = parseInt(document.getElementById('popularItemsinView').dataset.firstid);
    let count = 1;

    for(let i=1; i<=numberOfItems; i++) {
      if(i == (firstId - 1)) {
        document.getElementById('popItem'+i).classList.add('pos'+count);
        document.getElementById('popItem'+i).classList.remove('posLeftOut');
        count++;
      } else if(i > (firstId - 1) && count <= 4) {
        document.getElementById('popItem'+i).classList.add('pos' + count);
        document.getElementById('popItem'+i).classList.remove('pos' + (count - 1));
        count++;
      } else if(i > (firstId - 1) && count == 5) {
        document.getElementById('popItem'+i).classList.add('posRightOut');
        document.getElementById('popItem'+i).classList.remove('pos' + (count - 1));
        count++;
      }
    }
    document.getElementById('slideRight').classList.add('show');
    if((firstId - 1) == 1) {
      document.getElementById('slideLeft').classList.remove('show');
    }
    document.getElementById('popularItemsinView').dataset.firstid = firstId - 1;
  };

  var buttonRB = document.getElementById('slideRightBlog');
  if(buttonRB != null) {
    buttonRB.onclick = function () {
      let numberOfItems = parseInt(document.getElementById('blogItemsinView').dataset.blog);
      let firstId = parseInt(document.getElementById('blogItemsinView').dataset.firstid);
      let count = 1;
      let lastToBeChecked = 0;
      for(let i=1; i<=numberOfItems; i++) {
        if(i == firstId) {
          document.getElementById('blogItem'+i).classList.add('posLeftOut');
          document.getElementById('blogItem'+i).classList.remove('pos'+count);
          count++;
        } else if(i > firstId && count <= 3) {
          document.getElementById('blogItem'+i).classList.add('pos' + (count - 1));
          document.getElementById('blogItem'+i).classList.remove('pos' + count);
          count++;
        } else if(i > firstId && count == 4) {
          document.getElementById('blogItem'+i).classList.add('pos' + (count - 1));
          document.getElementById('blogItem'+i).classList.remove('posRightOut');
          lastToBeChecked = i;
          count++;
        }
      }
      document.getElementById('slideLeftBlog').classList.add('show');
      if(lastToBeChecked == numberOfItems) {
        document.getElementById('slideRightBlog').classList.remove('show');
      }
      document.getElementById('blogItemsinView').dataset.firstid = firstId + 1;
    };
  }

  var buttonLB = document.getElementById('slideLeftBlog');
  if(buttonLB != null) {
    buttonLB.onclick = function () {
      let numberOfItems = parseInt(document.getElementById('blogItemsinView').dataset.blog);
      let firstId = parseInt(document.getElementById('blogItemsinView').dataset.firstid);
      let count = 1;

      for(let i=1; i<=numberOfItems; i++) {
        if(i == (firstId - 1)) {
          document.getElementById('blogItem'+i).classList.add('pos'+count);
          document.getElementById('blogItem'+i).classList.remove('posLeftOut');
          count++;
        } else if(i > (firstId - 1) && count <= 3) {
          document.getElementById('blogItem'+i).classList.add('pos' + count);
          document.getElementById('blogItem'+i).classList.remove('pos' + (count - 1));
          count++;
        } else if(i > (firstId - 1) && count == 4) {
          document.getElementById('blogItem'+i).classList.add('posRightOut');
          document.getElementById('blogItem'+i).classList.remove('pos' + (count - 1));
          count++;
        }
      }
      document.getElementById('slideRightBlog').classList.add('show');
      if((firstId - 1) == 1) {
        document.getElementById('slideLeftBlog').classList.remove('show');
      }
      document.getElementById('blogItemsinView').dataset.firstid = firstId - 1;
    };
  }

  var button = document.getElementById('showAllPopular');
  button.onclick = function () {
    document.getElementById('popularMobile').classList.toggle('showAll');
    document.getElementById('showAllPopular').classList.toggle('show');
  }
})

var i = 0;
function typeWriter() {
  var speed = 50;
  var txt = document.getElementById("typewriteText").dataset.text;

  if (i < txt.length) {
    document.getElementById("typewriteText").innerHTML += txt.charAt(i);
    i++;
    setTimeout(typeWriter, speed);
  }
}